import {
  CreateUpdateEstimateItemDto,
  ProfileSchemaDto,
} from '../../../../common/pokCore/autogenerated/pokApiClient';
import {
  AmountFieldType,
  EstimateItemFieldsDefinition,
} from '../../../../common/pokCore/validation/estimateItemFields.definition';
import mathUtils from '../../../../utils/mathUtils';

import { getValue } from './utils';

export const calculateSalesFields = (
  obj: Partial<CreateUpdateEstimateItemDto>,
  schema: ProfileSchemaDto | undefined,
  item: CreateUpdateEstimateItemDto,
) => {
  if (!isSalesCalculation(obj)) {
    return obj;
  }

  if (obj.salesNetTotal !== undefined) {
    return obj;
  }

  const salesDiscountPercent = getValue(
    obj.salesDiscountPercent,
    item.salesDiscountPercent,
    0,
  );
  const salesSurchargePercent = getValue(
    obj.salesSurchargePercent,
    item.salesSurchargePercent,
    0,
  );
  const salesTechnicalCost = getValue(
    obj.salesNetTechnicalCost,
    item.salesNetTechnicalCost,
    0,
  );
  const salesBeerTax = getValue(obj.salesBeerTax, item.salesBeerTax, 0);
  const salesPrintingCosts = getValue(
    obj.salesPrintingCosts,
    item.salesPrintingCosts,
    0,
  );
  const salesOperatingFee = getValue(
    obj.salesOperatingFee,
    item.salesOperatingFee,
    0,
  );
  const salesBlockSurcharge = getValue(
    obj.salesBlockSurcharge,
    item.salesBlockSurcharge,
    0,
  );
  const salesTransferCosts = getValue(
    obj.salesTransferCosts,
    item.salesTransferCosts,
    0,
  );

  obj = calculateSalesCommission(obj, item);

  //rcSalesTotal = salesNet /  (1-salesDiscountPercent/100) * (1+salesSurchargePercent/100)
  if (obj.salesNet !== undefined) {
    const salesNet = getValue(obj.salesNet, item.salesNet, 0);

    const rcSalesTotal = mathUtils.divide(
      salesNet,
      mathUtils.multiply(
        mathUtils.subtract(1, mathUtils.divide(salesDiscountPercent, 100)),
        mathUtils.add(1, mathUtils.divide(salesSurchargePercent, 100)),
      ),
    );
    obj.rcSalesTotal = mathUtils.round(rcSalesTotal, 4).toString();
  } else if (
    !schema?.salesNet ||
    obj.rcSalesTotal !== undefined ||
    obj.salesDiscountPercent !== undefined ||
    obj.salesSurchargePercent !== undefined
  ) {
    //salesNet = rcSalesTotal * (1-salesDiscountPercent/100) * (1+salesSurchargePercent/100)
    const rcSalesTotal = getValue(obj.rcSalesTotal, item.rcSalesTotal, 0);
    const salesNet = mathUtils.multiply(
      rcSalesTotal,
      mathUtils.subtract(1, mathUtils.divide(salesDiscountPercent, 100)),
      mathUtils.add(1, mathUtils.divide(salesSurchargePercent, 100)),
    );
    obj.salesNet = mathUtils.round(salesNet, 4).toString();
  } else {
    obj.salesNet = item.salesNet;
  }

  obj = calculateSalesCommission(obj, item);

  const salesCommissionAmount = getValue(
    obj.salesCommissionAmount,
    item.salesCommissionAmount,
    0,
  );

  const salesNet = getValue(obj.salesNet, item.salesNet, 0); //?
  const salesNetTotal = mathUtils.add(
    mathUtils.round(salesNet),
    mathUtils.round(salesCommissionAmount),
    mathUtils.round(salesTechnicalCost),
    mathUtils.round(salesBeerTax),
    mathUtils.round(salesPrintingCosts),
    mathUtils.round(salesOperatingFee),
    mathUtils.round(salesBlockSurcharge),
    mathUtils.round(salesTransferCosts),
  );
  obj.salesNetTotal = mathUtils.round(salesNetTotal).toString();

  if (!schema?.salesNet) {
    obj.salesNet = undefined;
  }
  if (!schema?.rcSalesTotal) {
    obj.rcSalesTotal = undefined;
  }

  return obj;
};

const calculateSalesCommission = (
  obj: Partial<CreateUpdateEstimateItemDto>,
  item: CreateUpdateEstimateItemDto,
) => {
  //salesCommissionAmount = Netto sprzedaż * salesCommissionPercent / 100
  if (
    obj.salesCommissionPercent !== null &&
    (obj.salesCommissionPercent !== undefined ||
      (obj.salesNet !== undefined &&
        item.salesCommissionPercent !== undefined &&
        item.salesCommissionPercent !== null))
  ) {
    const salesCommissionPercent = getValue(
      obj.salesCommissionPercent,
      item.salesCommissionPercent,
      0,
    );
    const salesNet = getValue(obj.salesNet, item.salesNet, 0);
    const salesCommissionAmount = mathUtils.multiply(
      salesNet,
      mathUtils.divide(salesCommissionPercent, 100),
    );
    obj.salesCommissionAmount = salesCommissionAmount.toString();
  }

  //salesCommissionPercent = salesCommissionAmount / salesNet * 100
  if (
    obj.salesCommissionAmount !== null &&
    obj.salesCommissionAmount !== undefined
  ) {
    const salesCommissionAmount = getValue(
      obj.salesCommissionAmount,
      item.salesCommissionAmount,
      0,
    );
    const salesNet = getValue(obj.salesNet, item.salesNet, 0);
    if (salesNet !== 0) {
      const salesCommissionPercent = mathUtils.multiply(
        mathUtils.divide(salesCommissionAmount, salesNet),
        100,
      );
      obj.salesCommissionPercent = salesCommissionPercent.toString();
    }
  }
  return obj;
};

const isSalesCalculation = (obj: Partial<CreateUpdateEstimateItemDto>) => {
  if (
    !EstimateItemFieldsDefinition.amountFieldsKeys.some(
      field =>
        obj[field.name as keyof CreateUpdateEstimateItemDto] !== undefined &&
        field.type === AmountFieldType.sales,
    ) &&
    !EstimateItemFieldsDefinition.percentageFieldsKeys.some(
      field =>
        obj[field.name as keyof CreateUpdateEstimateItemDto] !== undefined &&
        field.type === AmountFieldType.sales,
    )
  ) {
    return false;
  }

  return true;
};
